'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _apolloBoost = require('apollo-boost');

var _apolloLinkBatchHttp = require('apollo-link-batch-http');

var _apolloLinkState = require('apollo-link-state');

var _graphFetchWrapper = require('./graph-fetch-wrapper');

var _graphFetchWrapper2 = _interopRequireDefault(_graphFetchWrapper);

var _linkError = require('./link-error');

var _linkError2 = _interopRequireDefault(_linkError);

var _linkSplit = require('./link-split');

var _linkSplit2 = _interopRequireDefault(_linkSplit);

var _linkSocketAbsinthe = require('./link-socket-absinthe');

var _linkSocketAbsinthe2 = _interopRequireDefault(_linkSocketAbsinthe);

var _linkSocketApollo = require('./link-socket-apollo');

var _linkSocketApollo2 = _interopRequireDefault(_linkSocketApollo);

var _compatibility = require('./compatibility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT = {
  fetchOptions: {
    credentials: 'include'
  }

  /**
   * Generates apollo client with a specified set of options based on default config.
   * We don't use a standard `apollo-boost` configurator because we need to support a custom refresh token flow.
   */
};var create = function create(_ref) {
  var createSocketLink = _ref.createSocketLink;
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _Object$assign = (0, _assign2.default)({}, DEFAULT, options),
        handleGraphQLError = _Object$assign.handleGraphQLError,
        handleNetworkError = _Object$assign.handleNetworkError,
        uri = _Object$assign.uri,
        uriRealtime = _Object$assign.uriRealtime,
        _Object$assign$should = _Object$assign.shouldBatch,
        shouldBatch = _Object$assign$should === undefined ? false : _Object$assign$should,
        _Object$assign$batchO = _Object$assign.batchOptions,
        batchOptions = _Object$assign$batchO === undefined ? {} : _Object$assign$batchO,
        clientState = _Object$assign.clientState,
        fetchOptions = _Object$assign.fetchOptions;

    (0, _compatibility.assertCompatibility)(options);

    var httpLinkOptions = {
      uri: uri,
      fetch: _graphFetchWrapper2.default,
      credentials: fetchOptions.credentials
    };
    var httpLink = shouldBatch ? new _apolloLinkBatchHttp.BatchHttpLink((0, _extends3.default)({}, httpLinkOptions, batchOptions)) : new _apolloBoost.HttpLink(httpLinkOptions);
    var endLink = uriRealtime ? (0, _linkSplit2.default)(createSocketLink({ uri: uriRealtime }), httpLink) : httpLink;
    var errorLink = (0, _linkError2.default)(handleNetworkError, handleGraphQLError);
    var stateLink = clientState ? (0, _apolloLinkState.withClientState)(clientState) : null;
    var link = _apolloBoost.ApolloLink.from([stateLink, errorLink, endLink].filter(Boolean));
    var cache = new _apolloBoost.InMemoryCache();
    return new _apolloBoost.ApolloClient({ cache: cache, link: link });
  };
};

var createClient = create({
  createSocketLink: _linkSocketApollo2.default
});
var createAbsintheClient = create({
  createSocketLink: _linkSocketAbsinthe2.default
});

exports.default = {
  createClientBuilder: create,
  createClient: createClient,
  createAbsintheClient: createAbsintheClient
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/graph-client/index.js
// module id = 1101
// module chunks = 0